import { ModalManager } from '@bob/library'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapMarkets } from '@websrc/DataMappers/mapMarkets'
import React from 'react'

import * as SC from './MainTopbarRegionModal.style'

export type MainTopbarRegionModalProps = ReturnType<typeof mapMarkets>

export function MainTopbarRegionModal({
  allMarkets,
  currentMarket,
  ...buttonProps
}: MainTopbarRegionModalProps) {
  const t = useStaticText()

  const renderModal = () => (
    <SC.Wrapper>
      <SC.Title>{t.region.change_region}</SC.Title>
      <SC.RegionsWrapper>
        {allMarkets.map((market) => {
          // surrounding the locale with / to make sure the link will be relative as normal a tags would work
          let toPath = `/${market.locale.replace('/', '')}/`

          // In China we need to prepend the full domain for non-China markets
          if (currentMarket.locale === 'zh-cn' && market.locale !== 'zh-cn') {
            toPath = `${process.env.DOT_COM_SITE_URL}${toPath}`
          }

          return (
            <SC.RegionItemWrapper key={market.locale} tablet={5} tabletOffset={1}>
              <SC.RegionItem
                data-link-name={`language-select:${market.locale}:${market.name}`}
                isRtl={market.isRtl}
                to={toPath}
              >
                <SC.RegionImg alt={market.name} src={market.flag.url} />
                {market.name}
              </SC.RegionItem>
            </SC.RegionItemWrapper>
          )
        })}
      </SC.RegionsWrapper>
    </SC.Wrapper>
  )

  return (
    <ModalManager key={'regionmodal'} modal={renderModal} position={'center'}>
      {(onClick) => (
        <SC.ButtonTertiary onClick={onClick} {...buttonProps} key={'localebutton'}>
          <SC.LangImg alt={currentMarket.name} src={currentMarket.flag.url} />
        </SC.ButtonTertiary>
      )}
    </ModalManager>
  )
}
